var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("エラーが発生しました。")]),_vm._v(" "),_c('router-link',{attrs:{"to":{path: '/'}}},[_vm._v("TOPへ戻る")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }